import type {
  PullRequestDiscussionInput,
  PullRequestEditResult,
  PullRequestReviewComment,
  PullRequestReviewVerdict,
} from "@afar-research/contracts";
import { createStore } from "zustand/vanilla";

export const emptyReviewDraft = () => ({
  body: "",
  verdict: "comment" as PullRequestReviewVerdict,
  comments: [] as readonly PullRequestReviewComment[],
  codeVersion: null as string | null,
  reply: "",
});
export function createPullRequestReviewSession() {
  return createStore<
    ReturnType<typeof emptyReviewDraft> & {
      command: PullRequestDiscussionInput | null;
      pending: boolean;
      result: PullRequestEditResult | null;
    }
  >(() => ({ ...emptyReviewDraft(), command: null, pending: false, result: null }));
}
export type PullRequestReviewSession = ReturnType<typeof createPullRequestReviewSession>;

/** Only hosted patch coordinates enter review drafts; checkout-local selections are never consulted. */
export function hostedReviewLines(patch: string) {
  const lines: { line: number; side: "LEFT" | "RIGHT"; text: string }[] = [];
  let left = 0;
  let right = 0;
  let inHunk = false;
  for (const text of patch.split("\n")) {
    const hunk = /^@@ -(\d+)(?:,\d+)? \+(\d+)(?:,\d+)? @@/.exec(text);
    if (hunk) {
      left = Number(hunk[1]);
      right = Number(hunk[2]);
      inHunk = true;
      continue;
    }
    if (!inHunk) continue;
    if (text.startsWith("-")) lines.push({ line: left++, side: "LEFT", text: text.slice(1) });
    else if (text.startsWith("+"))
      lines.push({ line: right++, side: "RIGHT", text: text.slice(1) });
    else if (text.startsWith(" ")) {
      lines.push({ line: right++, side: "RIGHT", text: text.slice(1) });
      left++;
    }
  }
  return lines;
}
